var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPolygon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_295_1911)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.2656 0.5H6.26562C2.95192 0.5 0.265625 3.18629 0.265625 6.5V14.5C0.265625 17.8137 2.95192 20.5 6.26562 20.5H14.2656C17.5793 20.5 20.2656 17.8137 20.2656 14.5V6.5C20.2656 3.18629 17.5793 0.5 14.2656 0.5Z",
    fill: "#1B1B1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2656 0.5H6.26562C2.95192 0.5 0.265625 3.18629 0.265625 6.5V14.5C0.265625 17.8137 2.95192 20.5 6.26562 20.5H14.2656C17.5793 20.5 20.2656 17.8137 20.2656 14.5V6.5C20.2656 3.18629 17.5793 0.5 14.2656 0.5Z",
    fill: "#9558FF",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.498 12.9365L16.661 11.0919C16.8285 10.9945 16.932 10.8126 16.932 10.617V6.92775C16.932 6.73219 16.8276 6.5502 16.661 6.45282L13.498 4.60819C13.3305 4.51081 13.1228 4.51081 12.9553 4.60819L9.79238 6.45282C9.62488 6.5502 9.52138 6.73219 9.52138 6.92775V13.5209L7.30352 14.8139L5.08564 13.5209V10.9339L7.30352 9.64077L8.76605 10.4941V8.7588L7.57453 8.06358C7.49236 8.01569 7.39833 7.99015 7.30352 7.99015C7.20871 7.99015 7.11389 8.01569 7.03251 8.06358L3.86964 9.90819C3.70214 10.0056 3.59863 10.1876 3.59863 10.3831V14.0724C3.59863 14.2672 3.70293 14.4499 3.86964 14.5474L7.03251 16.3919C7.20002 16.4894 7.40782 16.4894 7.57532 16.3919L10.7382 14.5474C10.9057 14.4499 11.0092 14.2679 11.0092 14.0724V7.4793L11.0495 7.45615L13.227 6.18622L15.445 7.4793V10.0663L13.227 11.3594L11.7661 10.5077V12.2429L12.9553 12.9365C13.1228 13.0339 13.3305 13.0339 13.498 12.9365Z",
    fill: "#9558FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_295_1911"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.265625 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolygon);
export default __webpack_public_path__ + "static/media/polygon.7f91302dfcc17211ca7e3051d5254099.svg";
export { ForwardRef as ReactComponent };